export default "__VITE_ASSET__ig_9WAJL__"